import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import ProjectFormPage from './pages/ProjectFormPage';
import SubmissionSuccess from './pages/SubmissionSuccess';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import FAQ from './pages/FAQ';
import ProjectStatus from './pages/ProjectStatus';
import ProtectedRoute from './components/ProtectedRoute';
import SecretKeyListener from './components/SecretKeyListener';

function App() {
  return (
    <Router>
      <SecretKeyListener />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/start" element={<ProjectFormPage variant="dark" />} />
        <Route path="/success" element={<SubmissionSuccess />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/track" element={<ProjectStatus />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
